<template>
  <v-container fluid>
    <v-row align="center" class="mb-2">
      <v-col>
        <h1>Invoicing Rules</h1>
      </v-col>
      <v-col cols="auto">
        <v-btn
          :color="editMode ? 'warning' : 'primary'"
          outlined
          @click="toggleEditMode"
        >
          <v-icon left>{{ editMode ? 'mdi-pencil-off' : 'mdi-pencil' }}</v-icon>
          {{ editMode ? 'Exit edit mode' : 'Edit rules' }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader
      :loading="loading"
      :transition-group="'scale-transition'"
      type="table">
      <InvoicingRulePanels
        :rules="invoicingRules"
        :editMode="editMode"
        @error="showError"
      ></InvoicingRulePanels>
    </v-skeleton-loader>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import InvoicingRulePanels from "@/components/InvoicingRules/InvoicingRulePanels";

export default {
    components: {
        InvoicingRulePanels
    },
    data() {
        return {
            loading: false,
            snackbar: false,
            snackbarText: "",
            snackbarColor: "",
            editMode: false
        };
    },
    computed: {
        invoicingRules() {
            return this.$store.state.invoiceRule.invoiceRules;
        }
    },
    methods: {
        showError(message) {
            this.snackbar = true;
            this.snackbarColor = "error";
            this.snackbarText = message;
        },
        toggleEditMode() {
            this.editMode = !this.editMode;
        }
    },
    created() {
        this.loading = true;
        this.$store.dispatch("invoiceRule/getInvoiceRules")
            .catch(() => {
                this.showError("Failed to load invoicing rules.");
            })
            .finally(() => {
                this.loading = false;
            });
    }
};
</script>

<style scoped>
h1 {
    margin-bottom: 1rem;
}
</style>
